<template>
  <div class="content">
    <div class="container">
      <div class="row m-3 mb-0">
        <legend>Subir aclaraciones</legend>
      </div>
      <div v-if="add_item">
        <div class="row m-3 mt-0">
          <div class="col-md-12 form-group pt-0 mb-0" style="text-align: left">
            Seleccione archivo en formato PDF
          </div>
          <div class="col-md-6 custom-file">
            <!-- accept=".pdf" -->
            <input id="xlsx" ref="xlsx" @change="addFile('xlsx')" v-validate="'required'" name="file" type="file" class="custom-file-input">
            <label class="custom-file-label" for="xlsx">Archivo seleccionado: {{ xlsx ? xlsx.name : '' }}</label>
            <br><small class="text-danger">{{ errors.first('file')}}</small>
          </div>

        </div>

        <div class="row justify-content-end m-3">
          <button class="btn btn-primary" @click.prevent="addItem()">
            <span v-if="!edit_item ">
              <i class="fa fa-plus"></i> Agregar </span>
            <span v-else>
              <i class="fa fa-save"></i> Guardar </span>
          </button>
          <button class="btn btn-danger ml-3" @click.prevent="cancelEdit()">
            <span>
              <i class="fa fa-times"></i> Cancelar </span>
          </button>
        </div>

        <div class="row ">
          <hr class=" bg-info">
        </div>
      </div>
      <div>
        <div class="row justify-content-end ml-3 mr-3">
          <!-- v-if="!add_item && fileExist" -->
          <button class="btn btn-primary" @click.prevent="showItem()" v-if="!add_item && fileExist">
            <span>
              <i class="fa fa-plus"></i> Agregar </span>
          </button>
        </div>
        <div class="row mt-3 mb-4">
          <div class="col-sm-12 col-md-12 col-lg-12">
            <v-text-field class="col-4 offset-8" v-model="search" append-icon="fa-search" placeholder="Buscar" single-line hide-details>
            </v-text-field>
            <v-data-table :headers="headers" :items="table_list" :items-per-page="5" :search="search" class="" :fixed-header="true">
              <template v-slot:item.acciones="{ item }">
                <div class="d-flex justify-content-center">

                  <b-button class="btn-s edit mr-2" variant="primary" @click.prevent="descargaAclaracion(item.file)">
                    <i class="far fa-file-pdf"></i>
                  </b-button>
                  <br>
                </div>
              </template>
              <template v-slot:item.eliminar="{ item }">
                <div class="d-flex justify-content-center">
                  <b-button @click.prevent="removeItem(item)" class="btn-s delete" variant="danger">
                    <i class="fas fa-times"></i></b-button>
                </div>
              </template>
              <template v-slot:item.anio="{ item }">
                <div>Declaración {{filterAnio(item.created_at)}}</div>
              </template>

              <template v-slot:item.file="{ item }">
                <div>{{dateFormat(item.created_at, true)}}</div>
              </template>
            </v-data-table>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="row" style="margin: 12px;">
      <div class="col-12 text-right" v-if="status_dec=1">
        <button class="btn btn-info btn-fill btn-wd btn-next" @click="siguente()">Siguiente</button>
      </div>
      <div class="col-12 text-right" v-if="status_dec=0">
        <button class="btn btn-info btn-fill btn-wd btn-next">Enviar</button>
      </div>
    </div> -->
  </div>
</template>
<script>
  import {
    FormWizard,
    TabContent
  } from "vue-form-wizard";
  import "vue-form-wizard/dist/vue-form-wizard.min.css";
  import moment from 'moment';
  import swal from "sweetalert2";
  export default {
    data() {
      return {
        rol: null,
        ip_id: null,
        el_archivo: "",
        wizardModel: {},
        fiscal: [],
        obligado: '',
        xlsx: 0,
        status_dec: 0,
        currentYear: '',
        add_item: false,
        edit_item: false,
        search: '',
        form_item: {},
        table_list: [],
        headers: [{
            text: 'Acciones',
            align: 'center',
            sortable: false,
            value: 'eliminar',
            class: ''
          }, {
            text: 'Documentos',
            align: 'center',
            sortable: false,
            value: 'acciones',
            width: "200px",

          },
          {
            text: 'Año',
            value: 'anio',
            align: 'center',
            class: '',
            width: "200px",
          },
          {
            text: 'Fecha y hora',
            value: 'file',
            align: 'center',
            class: ''
          },
        ],
      };
    },
    components: {
      FormWizard
    },
    computed: {
      fileExist() {
        let obj = this.table_list.find(o => moment(o.created_at, 'YYYY-MM-DD').format('YYYY') === this.currentYear);
        if (obj) {
          return false;
        } else {
          return true;
        }
      }
    },
    watch: {
      '$route': 'checkP'
    },
    methods: {
      enabledelete(item) {
        return moment(item.created_at, 'YYYY-MM-DD').format('YYYY') === this.currentYear;
      },
      dateFormat: function (date, time = false) {
        if (date) {
          if (time) {
            return moment(date).format('DD/MM/YYYY HH:mm:ss');
          } else {
            return moment(date, 'YYYY-MM-DD').format('DD/MM/YYYY');
          }
        }
      },
      descargaAclaracion(file) {
        const token = this.$jwt.getToken();
        const auth = 'Bearer ' + (token ? token.hash : "");

        //var url = [this.$http.options.root + 'declaraciones_aclaraciones/' + file];
        var url = ['https:' + this.$rootUrl + '/declaraciones_aclaraciones/' + file];

        window.open(url, '_blank');
      },
      hideButtons(date) {
        return moment(date, 'YYYY-MM-DD').format('YYYY');
      },
      showItem() {
        this.add_item = true;
        this.$validator.resume();
      },
      cancelEdit() {
        this.add_item = false;
        this.edit_item = false;
        this.form_item = {};
        this.$validator.pause();
      },
      addItem() {
        this.$validator.validateAll().then(response => {
          if (response) {
            const formData = new FormData();
            formData.append("upload_file", this.xlsx);
            //this.Ask("Esta apunto de subir el Acuse de la presentación de su declaración fiscal, si NO es el archivo correcto, después de subirlo deberá solicitar permiso para cualquier tipo de cambio ¿desea continuar?", () => {
            this.$http.post("aclaracion", formData).then(
              response => {
                this.StepOk("Guardado");
                if (!this.edit_item) {
                  this.table_list.unshift({
                    ...response.data.response
                  });
                } else {
                  let index = this.table_list.map(u => {
                    return u.id;
                  }).indexOf(response.data.response.id);
                  this.table_list.splice(index, 1, response.data.response);
                }
                this.cancelEdit();

              },
              error => {
                this.Err(error);
              }
            );
            //});
          }
        });
      },
      removeItem(item) {
        if (item.id !== null) {
          this.Ask("Desea borrar este registro", () => {
            this.$http.delete("aclaracion/" + item.id).then(response => {
              let index = this.table_list.map(u => {
                return u.id;
              }).indexOf(item.id);
              this.table_list.splice(index, 1);
              this.StepOk('Registro eliminado');
            }, error => {
              this.Err(error);
            });
          });
        }
      },
      checkP() {
        // && this.getKey('status_dec') == 1
        /* if (!(this.getKey('role') == 0 && this.getKey('grupo') != 3)) {
          localStorage.clear();
          this.$router.push('/login');
          this.$router.go();
        } */
      },

      addFile(tipo) {
        this.xlsx = this.$refs.xlsx.files[0];
      },
      siguente() {
        this.$router.push("observaciones");
      },
      /* validateFirstStep() {
        return this.$refs.firstStep.validate();
      },
      validateSecondStep() {
        return this.$refs.secondStep.validate();
      }, */

      /* wizardComplete() {
        // we gather models from all steps into one model
        this.wizardModel = {
          ...this.$refs.datosPersonales.model,
          ...this.$refs.firstStep.model,
          ...this.$refs.DatosCurriculares.model,
          ...this.$refs.DatosConyuge.model,
          ...this.$refs.secondStep.model
        };
        swal("Good job!", "You clicked the finish button!", "success");
      } */
    },
    created() {
      this.currentYear = moment().format('YYYY');

      this.checkP();
      this.ip_id = this.getId();
      this.status_dec = this.getKey('status_dec');

      // this.rol = this.getKey("grupo");

      this.$http.get("aclaracion/" + this.ip_id).then(
        response => {
          this.table_list = response.data.files;
        },
        error => {
          this.Err(error);
        }
      );
    },
    mounted() {
      //this.checkCatalogs();
    }
  };

</script>
<style>
  .vue-form-wizard .wizard-icon-circle.tab_shape {
    background-color: #9a9a9a !important;
    color: white;
  }


  .custom-file-label::after {
    content: "Buscar" !important;

  }

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Forms/Formularios/Aclaraciones/Aclaraciones.vue